import { render } from "./impedance_table.vue?vue&type=template&id=d4645152&scoped=true"
import script from "./impedance_table.vue?vue&type=script&lang=js"
export * from "./impedance_table.vue?vue&type=script&lang=js"

import "./impedance_table.vue?vue&type=style&index=0&id=d4645152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4645152"]])

export default __exports__